<app-home-navbar></app-home-navbar>
<div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
    <ol class="carousel-indicators">
        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
    </ol>
    <div class="carousel-inner">
        <div class="carousel-item active">
            <img class="d-block w-100" src="../../../assets/images/banner1-koala.jpg" alt="First slide">
            <!--
            <div class="carousel-caption d-none d-md-block">
                <h5>Primer banner</h5>
                <p>Este es el primer banner</p>
                <p><a class="btn btn-lg btn-success" href="#" role="button">Regístrate</a></p>
            </div>
            -->
        </div>
        <div class="carousel-item">
            <img class="d-block w-100" src="../../../assets/images/banner2-koala.jpg" alt="Second slide">
        </div>
        <div class="carousel-item">
            <img class="d-block w-100" src="../../../assets/images/banner3-koala.jpg" alt="Third slide">
        </div>
    </div>
    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
    </a>
</div>
<section class="business">
    <div class="container text-center">
        <h3 class="h3 text-gray-800">Empresas que confían en nosotros</h3>
        <img src="https://freelogo-assets.s3.amazonaws.com/sites/all/themes/freelogoservices/images/wp_logomaker%20/2021_optimized/familyfirst_counceling_services.png" height="120" />
        <img src="https://freelogo-assets.s3.amazonaws.com/sites/all/themes/freelogoservices/images/wp_logomaker%20/2021_optimized/four_seasons.png" height="120" />
        <img src="https://freelogo-assets.s3.amazonaws.com/sites/all/themes/freelogoservices/images/wp_logomaker%20/2021_optimized/rock_start.png" height="120" />
        <img src="https://freelogo-assets.s3.amazonaws.com/sites/all/themes/freelogoservices/images/wp_logomaker%20/2021_optimized/harmony_spa.png" height="120" />
        <img src="https://freelogo-assets.s3.amazonaws.com/sites/all/themes/freelogoservices/images/wp_logomaker%20/2021_optimized/all_start_burgers.png" height="120" />
    </div>
</section>
<section id="features" class="features">
    <div class="container text-center">
        <div class="row">
            <div class="col-lg-4 col-md-6 mb-lg-0 mb-5">
                <div class="avatar mx-auto">
                    <img src="https://image.freepik.com/vector-gratis/noticias-redes-sociales-consejos-concepto-abstracto-ilustracion-vectorial-marketing-redes-sociales-noticias-algoritmos-promocion-perfil-consejos-participacion-ultimas-actualizaciones-metafora-abstracta-consejos-contenido_335657-2268.jpg" class="rounded-circle z-depth-1"
                    alt="Sample avatar" height="250" width="250">
                </div>
                <h5 class="font-weight-bold mt-4 mb-3">Principales RRSS</h5>
            </div>

            <div class="col-lg-4 col-md-6 mb-lg-0 mb-5">
                <div class="avatar mx-auto">
                    <img src="https://image.freepik.com/vector-gratis/ilustracion-vector-concepto-abstracto-inteligencia-competitiva-inteligencia-empresarial-analisis-informacion-estrategia-investigacion-mercado-software-analisis-metafora-abstracta-entorno-competitivo_335657-2918.jpg" class="rounded-circle z-depth-1"
                    alt="Sample avatar" height="250" width="250">
                </div>
                <h5 class="font-weight-bold mt-4 mb-3">Estadísticas</h5>
            </div>

            <div class="col-lg-4 col-md-6 mb-lg-0 mb-5">
                <div class="avatar mx-auto">
                    <img src="https://image.freepik.com/vector-gratis/recomiende-diseno-plano-concepto-amigo_23-2148257862.jpg" class="rounded-circle z-depth-1"
                    alt="Sample avatar" height="250" width="250">
                </div>
                <h5 class="font-weight-bold mt-4 mb-3">Referidos</h5>
            </div>
        </div>
    </div>
</section>
<section class="feature1">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-6 mb-lg-0 mb-5 feature-col">
                <h1>Todas tus redes sociales a solo un clic de distancia</h1>
                <h5 class="h5 text-gray-800">Haz llegar tu contenido a todo tu público sin preocuparte del formato de cada red social. ¡Nosotros nos encargamos!</h5>
            </div>
            <div class="col-lg-6 col-md-6 mb-lg-0 mb-5 text-center">
                <img width="350" src="https://image.freepik.com/vector-gratis/ilustracion-concepto-online_114360-1009.jpg" />
            </div>
        </div>
    </div>
</section>
<section class="feature2">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-6 mb-lg-0 mb-5 text-center">
                <img height="350" src="../../../assets/images/analytics-koala.png" />
            </div>
            <div class="col-lg-6 col-md-6 mb-lg-0 mb-5 feature-col">
                <h1>¿Qué contenido triunfa entre tus seguidores?</h1>
                <h5 class="h5 text-gray-800">Evite utilizar múltiples plataformas y hojas de cálculo para analizar sus datos. Con Koala podrá analizar sus estadísticas y mejorar su estrategia en un mismo lugar.</h5>
            </div>
        </div>
    </div>
</section>
<section class="feature3">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-6 mb-lg-0 mb-5 feature-col">
                <h1>Comparte tus enlaces de referidos de manera sencilla</h1>
                <h5 class="h5 text-gray-800">Guarda mensajes predefinidos para cada programa de referidos y hazlos llegar a tu audiencia.</h5>
            </div>
            <div class="col-lg-6 col-md-6 mb-lg-0 mb-5 text-center">
                <img height="350" src="https://image.freepik.com/vector-gratis/recomiende-concepto-amigo-telefono-inteligente_23-2148280528.jpg" />
            </div>
        </div>
    </div>
</section>
<section class="register">
    <div class="container text-center">
        <h1>Distribuye contenido en tus redes sociales con Koala</h1>
        <h5 class="h5 text-gray-800">Preocúpate de crear contenido de calidad, nosotros nos encargamos de hacerlo llegar a tu comunidad</h5>
        <a class="btn btn-success my-2 my-sm-0" href="register" role="button">Regístrate ahora</a>
    </div>
</section>
<section id="team" class="team">
    <div class="container text-center">
        <h1 class="h1">Nuestro equipo</h1>
        <div class="row">
            <div class="col-lg-4 col-md-6 mb-lg-0 mb-5 team">
                <div class="avatar mx-auto">
                    <img src="../../../assets/images/jonay.jpg" class="rounded-circle z-depth-1 "
                    alt="Sample avatar" height="200" width="200">
                </div>
                <h5 class="font-weight-bold mt-4 mb-3">Jonay Brito</h5>
                <p class="text-uppercase blue-text"><strong>Fullstack Developer</strong></p>
                <ul class="list-unstyled mb-0">
                <!-- Linkedin -->
                <a class="p-2 fa-lg fb-ic link" href="https://www.linkedin.com/in/jonaybrito/" target="_blank">
                    <i class="fab fa-linkedin-in blue-text"> </i>
                </a>
                <!-- Github -->
                <a class="p-2 fa-lg fb-ic" href="https://github.com/Jormais" target="_blank">
                    <i class="fab fa-github blue-text"> </i>
                </a>
                </ul>
            </div>

            <div class="col-lg-4 col-md-6 mb-lg-0 mb-5 team">
                <div class="avatar mx-auto">
                <img src="../../../assets/images/irene.jpg" class="rounded-circle z-depth-1 "
                    alt="Sample avatar" height="200" width="200">
                </div>
                <h5 class="font-weight-bold mt-4 mb-3">Irene Gómez</h5>
                <p class="text-uppercase blue-text"><strong>Fullstack Developer</strong></p>
                <ul class="list-unstyled mb-0">
                <!-- Linkedin -->
                <a class="p-2 fa-lg fb-ic" href="https://www.linkedin.com/in/irenegomezvera/" target="_blank">
                    <i class="fab fa-linkedin-in blue-text"> </i>
                </a>
                <!-- Github -->
                <a class="p-2 fa-lg fb-ic" href="https://github.com/irenegv22" target="_blank">
                    <i class="fab fa-github blue-text"> </i>
                </a>
                </ul>
            </div>

            <div class="col-lg-4 col-md-6 mb-lg-0 mb-5 team">
                <div class="avatar mx-auto">
                <img src="../../../assets/images/aitor.jpg" class="rounded-circle z-depth-1 "
                    alt="Sample avatar" height="200" width="200">
                </div>
                <h5 class="font-weight-bold mt-4 mb-3">Aitor Santana</h5>
                <p class="text-uppercase blue-text"><strong>Fullstack Developer</strong></p>
                <ul class="list-unstyled mb-0">
                <!-- Linkedin -->
                <a class="p-2 fa-lg fb-ic" href="https://www.linkedin.com/in/aitorscinfo/" target="_blank">
                    <i class="fab fa-linkedin-in blue-text"> </i>
                </a>
                <!-- Github -->
                <a class="p-2 fa-lg fb-ic" href="https://github.com/Sstark97" target="_blank">
                    <i class="fab fa-github blue-text"> </i>
                </a>
                </ul>
            </div>

            <div class="col-lg-4 col-md-6 mb-lg-0 mb-5 team">
                <div class="avatar mx-auto">
                    <img src="../../../assets/images/celeste.jpg" class="rounded-circle z-depth-1 "
                    alt="Sample avatar" height="200" width="200">
                </div>
                <h5 class="font-weight-bold mt-4 mb-3">Celeste Arbelo</h5>
                <p class="text-uppercase blue-text"><strong>Fullstack Developer</strong></p>
                <ul class="list-unstyled mb-0">
                <!-- Linkedin -->
                <a class="p-2 fa-lg fb-ic" href="https://www.linkedin.com/in/celeste-arbelo-garc%C3%ADa/" target="_blank">
                    <i class="fab fa-linkedin-in blue-text"> </i>
                </a>
                <!-- Github -->
                <a class="p-2 fa-lg fb-ic" href="https://github.com/celesteag" target="_blank">
                    <i class="fab fa-github blue-text"> </i>
                </a>
                </ul>
            </div>

            <div class="col-lg-4 col-md-6 mb-lg-0 mb-5 team">
                <div class="avatar mx-auto">
                    <img src="../../../assets/images/santiago.jpg" class="rounded-circle z-depth-1"
                    alt="Sample avatar" height="200" width="200">
               </div> 
                <h5 class="font-weight-bold mt-4 mb-3">Santiago Brito</h5>
                <p class="text-uppercase blue-text"><strong>Fullstack Developer</strong></p>
                <ul class="list-unstyled mb-0">
                <!-- Linkedin -->
                <a class="p-2 fa-lg fb-ic" href="https://www.linkedin.com/in/santiagobritogarcia/" target="_blank">
                    <i class="fab fa-linkedin-in blue-text"> </i>
                </a>
                <!-- Github -->
                <a class="p-2 fa-lg fb-ic" href="https://github.com/santiagobrito94" target="_blank">
                    <i class="fab fa-github blue-text"> </i>
                </a>
                </ul>
            </div>
  
        </div>
    </div>
</section>

<app-footer></app-footer>
